import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../services/api';

export const useInviteCodesCanCreate = () => {
    return useQuery({
        queryKey: ['invite-codes-can-create'],
        queryFn: () => api.getInviteCodesCanCreate(),
        staleTime: 5 * 60 * 1000,
    });
};

export const useInviteCodes = () => {
    return useQuery({
        queryKey: ['invite-codes'],
        queryFn: () => api.getInviteCodes(),
    });
};

export const useCreateInviteCode = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: () => api.createInviteCode(),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['invite-codes'] });
        },
    });
};

export const useDeleteInviteCode = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: ({ uid }) => api.deleteInviteCode(uid),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['invite-codes'] });
        },
    });
};
